<template>
    <tr :class="['driver-dashboard-version-item', { 'is-default-version': isDefaultVersion }]">
        <td :class="['driver-dashboard-version-item__id', isDefaultVersion ? '' : '']">
            <span>{{ `${version.id}` }}</span>
            <span class="element-badge is--active has--circle" v-if="isDefaultVersion">Default</span>
        </td>
        <td>
            <p>{{ version.description }}</p>
            <!-- <app-button
                class="btn-sm ml-auto"
                :disabled="true || isSyncing"
                @click="sync()">
                {{ isSyncing ? 'Syncing...' : 'Sync' }}
            </app-button> -->
        </td>
        <td>{{ version.created_at ? localizeDate(version.created_at).fromNow() : '' }}</td>
        <td>{{ version.creator ? version.creator.name : '' }}</td>
        <td>
            <ul v-if="allProjects.length"
            class="driver-dashboard-version-item__list">
                <driver-dashboard-project-item
                    v-for="project in allProjects"
                    :key="`project-${project.id}`"
                    :project="project"
                    :version="version">
                </driver-dashboard-project-item>
            </ul>
        </td>
    </tr>
</template>

<script>
import Echo from '../helpers/echo'
import api from '../api/drivers'
import { localizeDate } from '../helpers/util'
import DriverDashboardProjectItem from './DriverDashboardProjectItem.vue'

export default {
    components: { DriverDashboardProjectItem },
    props: {
        version: {
            type: Object,
            default: () => ({
                description: ''
            })
        },
        isDefaultVersion: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            isSyncing: false,
            errors: []
        }
    },
    computed: {
        allProjects () {
            return this.version.all_projects
        },
        isUsed () {
            return this.version.all_projects.length
        }
    },
    methods: {
        localizeDate,
        setupEchoListener () {
            // subscribe to channel for each course
            Echo.private(`App.Models.Driver.${this.driver.id}`)
                .notification((notification) => {
                    if (notification.progress === 1) {
                        this.isSyncing = false
                    }

                    const model = _.get(notification, 'model')
                    if (model) {
                        this.driver = model
                    }
                })
        },
        async sync () {
            this.isSyncing = true

            // api call to process
            const result = await api.sync(this.version.id)
            // console.log(result)

            if (result.errors) {
                // catch errors
                this.errors = result
            } else {
                // update driver
                this.driver = result
            }
        },
        setDefaultVersion () {
            this.$emit('set-default', this.version)
        }
    },
    created () {
        // this.setupEchoListener()
    }
}
</script>
